import { LoadableAfterPaint } from '@confluence/loadable';

export const ConversationAssistantNavBarButton = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConversationAssistantNavBarButton" */ '../src/navBarButton.tsx'
			)
		).ConversationAssistantNavBarButton,
});
